






import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateFormatter } from "../../../domain/system/DateFormatter";
import { ModelEditableMixin } from "../mixins";

@Component
export default class DatePicker extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isAlert: boolean;

  data() {
    return {
      selectedDate: null as Date,
    };
  }
  selectedDate: Date;

  get displayText(): string {
    return this.editingSource
      ? DateFormatter.format(this.editingSource as Date, "YYYY/MM/DD")
      : null;
  }

  set displayText(value: string) {
  }

  get calenderStyles(): any {
    return {
      color: this.isAlert ? this.alertColor : null,
      backgroundColor: this.isAlert ? this.alertBackgroundColor : null,
    };
  }

  get alertColor(): string {
    return this.$configuration.style.alertIndication.color;
  }

  get alertBackgroundColor(): string {
    return this.$configuration.style.alertIndication.backgroundColor;
  }

  async showCalender(): Promise<void> {
    const result = await this.$commonDialogs.date.dateSelector.show(this.editingSource);
    if (result === undefined) { return; }
    this.editingSource = result;
  }
}
